export default __webpack_public_path__ + "89a598137386118bf334ab3c6517af5b.png";